<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import InputCardHeader from './InputCardHeader.vue';
import SimulationFields from './SimulationFields.vue';

const { t } = useI18n();
const expanded = ref(false);
void t;
</script>

<template>
  <article class="bg-bg-card rounded-extra-large border border-border-light overflow-hidden">
    <button
      type="button"
      class="w-full text-left p-lg outline-none focus-visible:ring-2 focus-visible:ring-brand-300 focus-visible:ring-offset-2 focus-visible:ring-offset-bg-page transition-colors duration-fast hover:bg-grey-50 active:bg-grey-100"
      :aria-expanded="expanded"
      @click="expanded = !expanded"
    >
      <div class="flex items-center gap-sm">
        <div class="flex-1">
          <InputCardHeader :title="t('cardSimulationTitle')" icon="chart">
            <template #leading>
              <span class="w-8 h-8 rounded-pill bg-brand-100 text-label-small font-bold text-brand-700 flex items-center justify-center">2</span>
            </template>
          </InputCardHeader>
        </div>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="text-text-tertiary transition-transform"
          :class="expanded ? 'rotate-180' : ''"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </div>
    </button>
    <div v-if="expanded" class="px-lg pb-lg">
      <SimulationFields />
    </div>
  </article>
</template>
